import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import SyntheticEvent from 'UIComponents/core/SyntheticEvent';
import { RadioInput } from 'foundations-components/transitional/components/RadioInput';
import { ToggleGroup } from 'foundations-components/transitional/components/ToggleGroup';
import { FormControl } from 'foundations-components/transitional/components/FormControl';
import { setErrorMessages, getShowAllErrors } from '../../state/errorMessagesSlice';
import { useGetErrorMessagesAndTranslations } from '../../hooks/useGetErrorMessagesAndTranslations';
import { jsx as _jsx } from "react/jsx-runtime";
const CustomFormFieldRadio = ({
  disabled,
  formField,
  onChange,
  value
}) => {
  const dispatch = useDispatch();
  const showAllErrors = useSelector(getShowAllErrors);
  const fieldLabel = formField.label;
  const fieldName = formField.name;
  const isError = showAllErrors && formField.required && !value;
  const errorKey = `empty${fieldLabel}`;
  const errorMessage = useGetErrorMessagesAndTranslations().get(errorKey);
  useEffect(() => {
    dispatch(setErrorMessages({
      [errorKey]: {
        isError,
        customFormFieldLabel: fieldLabel
      }
    }));
  }, [isError, dispatch, fieldLabel, errorKey]);
  return /*#__PURE__*/_jsx(FormControl, {
    help: formField.description,
    label: fieldLabel,
    required: formField.required,
    error: isError,
    validationMessage: isError && errorMessage,
    children: /*#__PURE__*/_jsx(ToggleGroup, {
      name: fieldName,
      children: formField.options.map(option => /*#__PURE__*/_jsx(RadioInput, {
        "data-test-id": "custom-form-field-radio-input",
        checked: option.value === value,
        disabled: disabled,
        onChange: () => onChange(SyntheticEvent(option.value)),
        children: option.label
      }, `${fieldName}-${option.value}`))
    })
  });
};
export default CustomFormFieldRadio;